import { Box, Popover, TableCell } from '@ksyos/design-system';
import { TextWithMatchingTermInBold } from './common';

export interface ITableCellTextFieldWithMoreButtonProps {
    characterLimit: number;
    content: string;
    searchTerm?: string | null;
}

export function TableCellTextFieldWithMoreButton(props: ITableCellTextFieldWithMoreButtonProps) {
    const text =
        props.content.length <= props.characterLimit
            ? props.content
            : props.content.substring(0, props.characterLimit) + '...';

    return (
        <TableCell>
            {props.content.length > props.characterLimit ? (
                <Box
                    as="span"
                    onClick={(e) => e.stopPropagation()}
                >
                    <Popover
                        content={
                            <TextWithMatchingTermInBold
                                searchTerm={props.searchTerm || null}
                                text={props.content}
                            />
                        }
                    >
                        {text}
                    </Popover>
                </Box>
            ) : (
                <TextWithMatchingTermInBold
                    searchTerm={props.searchTerm || null}
                    text={text}
                />
            )}
        </TableCell>
    );
}
